import { useEffect, useState } from 'react';

type UseZoomTransitionReturn = {
  setTransitionCallback: (value: () => void) => void;
};

const usePanZoomBoxTransition = (
  ref: HTMLDivElement,
  defaultTime = 100,
): UseZoomTransitionReturn => {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const [transitionCallback, setTransitionCallback] = useState<() => void>(null);

  useEffect(() => {
    if (!ref) return;
    if (transitionCallback != null) {
      ref.style.transition = `transform ${defaultTime}ms`;
      transitionCallback();
    }
  }, [transitionCallback, ref, defaultTime]);

  useEffect(() => {
    if (!ref) return;
    const resetTransitionTime = () => {
      ref.style.transition = `transform 0ms`;
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      setTransitionCallback(null);
    };

    ref.addEventListener('transitionend', resetTransitionTime);
    return () => {
      ref.removeEventListener('transitionend', resetTransitionTime);
    };
  }, [ref, transitionCallback]);

  return { setTransitionCallback };
};

export default usePanZoomBoxTransition;
